function importAll(r) { r.keys().forEach(r) }

window.jQuery = window.$ = require('jquery')
window.d3 = require('d3')
window.c3 = require('c3')
window.Mousetrap = require('mousetrap')

// Polyfills
import 'babel-polyfill'

// Importando dependências
import 'jquery-ui'
import 'bootstrap/dist/js/bootstrap'
import 'ace-builds/src-noconflict/ace'

// Importando o AngularJS e módulos necessários.
import 'angular'
import 'angular-animate'
import 'angular-cookies'
import 'angular-file-saver'
import 'angular-file-upload'
import 'angular-input-masks'
import 'angular-inview'
import 'angular-messages'
import 'angular-promise-tracker'
import '@uirouter/angularjs'
import 'angular-sanitize'
import 'angular-ui-ace'
import 'angular-ui-date'
import 'angular-xeditable/dist/js/xeditable'
import 'c3-angular'
import 'checklist-model'
import 'ng-file-upload'

// Importando os arquivos JS do módulo 'eficiencia-fiscal'.
import './utils/libs/angular-locale_pt-br.js'
import './utils/libs/angular-ui-select.js'
import './utils/libs/angular.paging.js'
import './utils/libs/ng-table.min.js'
import './utils/libs/pace.min.js'
import './utils/libs/ui-bootstrap.js'
import './utils/libs/ui-utils.js'
import './utils/cbkSupport.js'
import './smart-admin/SmartNotification.js'
import './smart-admin/app.config'
import './smart-admin/app'

import './modules/eficiencia-fiscal/module.js'
import './modules/eficiencia-fiscal/service/base/abstractService.coffee'
import './modules/eficiencia-fiscal/service/abstractService.coffee'
import './modules/eficiencia-fiscal/controller/abstractController.coffee'
import './modules/eficiencia-fiscal/controller/abstractCrudController.coffee'

importAll(require.context('./modules/eficiencia-fiscal', true, /\.(coffee|js|html)$/))

// Arquivos CSS
import './assets/css/bootstrap.css'
import './assets/css/font-awesome.css'
import './assets/css/smartadmin-production.min.css'
import './assets/css/angular-xeditable.css'
import './assets/css/angular-ui-select.min.css'
import './assets/css/nv.d3.css'
import './assets/css/ng-table.css'
import './assets/css/angular-xeditable.css'
import './assets/css/c3.min.css'
import './assets/css/grid.css'
import './assets/scss/style.scss'

importAll(require.context('./modules/eficiencia-fiscal', true, /\.(css|s[ca]ss)$/))

window.Pace.options.ajax.trackWebSockets = false;
